<mat-dialog-content style="max-height: 60vw">
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li style="font-size: xx-large;font-weight: bold;">Actions</li>
                </ul>

               <ul>
                <label style="font-size: large;font-weight: bold;">{{patientid}}</label>
                <label style="font-size: large;font-weight: bold;">     </label>
                <label style="font-size: large;font-weight: bold;">{{patientname}} - {{visittype}} - {{id}}</label>
              </ul>
              <ul>
                <label style="font-size: large;font-weight: bold;">Date :{{patdate}}</label>
                <label style="font-size: large;font-weight: bold;">   Attendance Time  </label>
                <label style="font-size: large;font-weight: bold;">{{attendtime}}</label>
                </ul>
            </div>
        </div>
    </div>
  </section>
  <div id="w3l-appointment">
    <section class="appointment-section section-gap">

      <div class="wrapper">
              <div class="appointment-form">
                  <form action="#" method="post">
                    <div class="styled-input">
                      <mat-chip-list disabled={{DisableCreateFile}} >
                        <a *ngIf= "!HedenCreateFile"  href="Dbank" (click)="DataBankEntry()"  style="cursor: grab;width: 80%;" >

                          <mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;" disabled={{DisableCreateFile}}><i class="fa fa-heartbeat" style='color:rgb(255, 255, 255)'></i>  {{'1. Create New File' | translate }}</mat-chip></a>
                          <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{pattime}}</label>
                          <label style="width: 2%;"></label>
                          <img  *ngIf= "!HedenCreateFile"  src={{imagepath0}} style="left: 1300px;" height="20px" width="20px"/>
<!--

                        <a *ngIf= "!HedenCreateFile"  href="Dbank" (click)="DataBankEntry()"  style="cursor: grab;width: 80%;" >
                        <mat-chip color="primary" style="cursor: grab;font-size: large; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;width: 50% !important;"  disabled={{DisableCreateFile}}><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'1. Create New File' | translate }} </mat-chip></a>
                        <label style="width: 10%;position: absolute;left: 60%;color: white;">{{pattime}}</label>
                        <label style="width: 1%;"></label>
                        <img  *ngIf= "!HedenCreateFile" src={{imagepath0}} style="left: 1300%;" height="20%" width="20%"/> -->
                      </mat-chip-list>

                    </div>
                    <div class="styled-input" >
                      <mat-chip-list disabled={{DisableNursing}}>
                        <a (click)="NursingEntry()" style="cursor: grab;width: 80%;">
                        <mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;" disabled={{DisableNursing}}><i class="fa fa-heartbeat" style='color:rgb(255, 255, 255)'></i>  {{'2. Nurse Assessment' | translate }}</mat-chip></a>
                        <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{nursetime}}</label>
                        <label style="width: 2%;"></label>
                        <img src={{imagepath1}} style="left: 1300px;" height="20px" width="20px"/>
                      </mat-chip-list>
                    </div>
                    <!-- <div class="styled-input">
                        <mat-chip-list >
                          <a  *ngIf="!HedenObservation" href="DoctorObservation" (click)="DoctorObservation()" style="cursor: grab;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;" disabled={{DisableObservation}}><i class="fa fa-user-md" style='color:rgb(255, 255, 255)'></i>  {{'3. Physician Assessment' | translate }}</mat-chip></a>
                          <label style="width: 10%;position: absolute;left: 1050px;color: white;">{{trtime}}</label>
                          <label style="width: 2%;"></label>
                          <img src={{imagepath2}} style="left: 1300px;" height="20px" width="20px"/>
                        </mat-chip-list>
                    </div> -->
                    <div class="styled-input">
                      <mat-chip-list >
                        <a  *ngIf="!HedenObservation" href="DoctorObservationTab" (click)="DoctorObservation()" style="cursor: grab;width: 80%;">
                          <mat-chip color="primary" style="cursor: grab;font-size: large;height: 50px;width: 100%; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;" disabled={{DisableObservation}}>
                            <i class="fa fa-user-md" style='color:rgb(255, 255, 255)'></i>  {{'3. Physician Assessment' | translate }}
                          </mat-chip>
                        </a>
                        <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{trtime}}</label>
                        <label style="width: 2%;"></label>
                        <img src={{imagepath2}} style="left: 1200px;" height="20px" width="20px"/>
                      </mat-chip-list>
                  </div>
                    <div class="styled-input">
                      <mat-chip-list >
                        <a  *ngIf="!HedenDocument" href="PatientDocumentNew"  target="_blank"  (click)="UploadDocuments()" style="cursor: grab;width: 80%;">
                          <mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;" disabled={{DisableDocument}}><i class="fa fa-paperclip" style='color:rgb(255, 255, 255)'></i>  {{'4. Patient investigations' | translate }}</mat-chip></a>
                        <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{doctime}}</label>
                        <label style="width: 2%;"></label>
                        <img src={{imagepath3}} style="left: 1300px;" height="20px" width="20px"/>

                      </mat-chip-list>
                    </div>
                    <div class="styled-input">
                      <mat-chip-list >
                        <a *ngIf="!HedenTreatment" href="PreparationOrderNew" target="_blank"  (click)="OpenPreparation()"  style="cursor: grab;width: 80%;" ><mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;"  disabled={{DisablePreapartion}}><i class="fa fa-paperclip" style="color:rgb(255, 255, 255);" ></i>  {{'5. Clinical Pharmacy' | translate }}</mat-chip></a>
                        <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{potime}}</label>
                        <label style="width: 2%;"></label>
                        <img *ngIf="!HedenTreatment" src={{imagepath4}} style="left: 1300px;" height="20px" width="20px"/>

                      </mat-chip-list>
                    </div>
                                        <div class="styled-input">
                      <mat-chip-list >
                        <a *ngIf="!HedenTreatment" href="roundandclinic" target="_blank"  (click)="openRoundAndClinics()"  style="cursor: grab;width: 80%;" ><mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;"  disabled={{DisableRoundandClinic}}><i class="fa fa-paperclip" style="color:rgb(255, 255, 255);" ></i>  {{'6. Round And Clinic' | translate }}</mat-chip></a>
                        <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{potime}}</label>
                        <label style="width: 2%;"></label>
                        <img *ngIf="!HedenTreatment" src={{imagepath4}} style="left: 1300px;" height="20px" width="20px"/>

                      </mat-chip-list>
                    </div>
                    <div class="styled-input">
                      <mat-chip-list >
                        <a *ngIf="!HedenTreatmentNurse" href="PreparationOrderNurse" target="_blank"  (click)="OpenPreparation()"  style="cursor: grab;width: 80%;" ><mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 50px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;"  disabled={{DisablePreapartionNurse}}><i class="fa fa-paperclip" style="color:rgb(255, 255, 255);" ></i>  {{'7. Clinical Pharmacy' | translate }}</mat-chip></a>
                        <label style="width: 5%;position: absolute;left: 1050px;color: white;">{{potime}}</label>

                        <label style="width: 2%;"></label>
                        <img *ngIf="!HedenTreatmentNurse" src={{imagepath4}} style="left: 1300px;" height="20px" width="20px"/>

                      </mat-chip-list>
                    </div>
                    <div class="styled-input">
                      <mat-chip-list  >
                        <a (click)="closedialog()" style="cursor: grab;text-align: center;width: 80%;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 100%;height: 70px; background-color: #324d8c;color:rgb(255, 255, 255);text-align: center;align-content: center;"><i class="fa fa-home" style="color:rgb(255, 255, 255);" ></i>  {{'Exit' | translate }}</mat-chip></a>
                      </mat-chip-list>
                    </div>
                        <!-- <div class="fields-grid">
                        <a>
                          <button type="button" (click)="closedialog()" class="theme-button btn" style="width: 100%;height: 100px;" name="Back"><i class="fa fa-home" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Home' | translate }}</button>
                         </a>
                      </div> -->
                  </form>
              </div>

      </div>
  </section>
  </div>


</mat-dialog-content>
